import { bool, func, array } from "prop-types"
import EditCategories from "./EditCategories"
import StaticCategories from "./StaticCategories"

const Categories = ({
  eventIsArchived,
  isEditing,
  categories,
  onCategoryChange,
  onModalChange,
  onModalClose,
  selectedCategories,
  isAdmin
}) => {
  const handleAdd = ({ target: { value: categoryId } }) => {
    let categoriesToChange = []

    if (selectedCategories.find(sc => sc.id === categoryId)) {
      categoriesToChange = selectedCategories.map(sc =>
        sc.id === categoryId ? { ...sc, action: null } : sc
      )
    } else {
      const category = categories.find(c => c.id === categoryId)
      categoriesToChange = [
        ...selectedCategories,
        {
          id: categoryId,
          name: category.attributes.name,
          action: "add_category"
        }
      ]
    }

    onCategoryChange(categoriesToChange)
  }

  const handleRemove = categoryId => {
    let categoriesToChange = []
    const category = selectedCategories.find(sc => sc.id === categoryId)

    if (category.action === null) {
      categoriesToChange = selectedCategories.map(sc =>
        sc.id === categoryId ? { ...sc, action: "remove_category" } : sc
      )
    } else if (category.action === "add_category") {
      categoriesToChange = selectedCategories.filter(sc => sc.id !== categoryId)
    }

    onCategoryChange(categoriesToChange)
  }

  return isEditing ? (
    <EditCategories
      onAdd={handleAdd}
      onRemove={handleRemove}
      categories={categories}
      selectedCategories={selectedCategories}
      eventIsArchived={eventIsArchived}
      onModalChange={onModalChange}
      onModalClose={onModalClose}
      isAdmin={isAdmin}
    />
  ) : (
    <StaticCategories selectedCategories={selectedCategories} categories={categories} />
  )
}

Categories.propTypes = {
  eventIsArchived: bool,
  isEditing: bool,
  categories: array,
  selectedCategories: array,
  onCategoryChange: func,
  onModalChange: func,
  onModalClose: func,
  isAdmin: bool
}

export default Categories
